export const Paths = {
    default: '/api/customer-portal/payments/customers',
    search: '/customer-portal/v1/person/paymentcustomer',
    relatedInvoices: '/api/customer-portal/payments/relatedinvoices'
};
